/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCloneReportDefinitionMutationResponse, AuditReportsCloneReportDefinitionPathParams, AuditReportsCloneReportDefinition401, AuditReportsCloneReportDefinition403, AuditReportsCloneReportDefinition404 } from "../models/AuditReportsCloneReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsCloneReportDefinition } from "../axios/auditReportsCloneReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsCloneReportDefinitionMutationKey = () => [{ url: '/audit-reports/v1/report-definitions/:id/clone' }] as const

export type AuditReportsCloneReportDefinitionMutationKey = ReturnType<typeof auditReportsCloneReportDefinitionMutationKey>

export function auditReportsCloneReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsCloneReportDefinitionMutationKey()
        return mutationOptions<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, {id: AuditReportsCloneReportDefinitionPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsCloneReportDefinition(id, config)
          },
        })

}

/**
 * @description Creates a copy of an existing report definition. The cloned definition uses the same blueprint version as the source and is not set as default.
 * @summary Clone report definition
 * {@link /audit-reports/v1/report-definitions/:id/clone}
 */
export function useAuditReportsCloneReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, {id: AuditReportsCloneReportDefinitionPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsCloneReportDefinitionMutationKey()

          const baseOptions = auditReportsCloneReportDefinitionMutationOptions(config) as UseMutationOptions<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, {id: AuditReportsCloneReportDefinitionPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, {id: AuditReportsCloneReportDefinitionPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsCloneReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCloneReportDefinition401 | AuditReportsCloneReportDefinition403 | AuditReportsCloneReportDefinition404>, {id: AuditReportsCloneReportDefinitionPathParams["id"]}, TContext>
      
}